import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.notification-modal-icon-success { color: ${dt('notificationModal.icon.success.color')}; }
.notification-modal-icon-danger { color: ${dt('notificationModal.icon.danger.color')}; }
.notification-modal-icon-warn { color: ${dt('notificationModal.icon.warn.color')}; }
.notification-modal-icon-info { color: ${dt('notificationModal.icon.info.color')}; }
`;
